import { gsap } from 'gsap';

class MobileMenu {
    constructor() {
        this.header = document.querySelector('.header');
        this.trigger = document.querySelector('.header-burger');
        this.nav = document.querySelector('#mobile-menu');
        this.navItems = document.querySelectorAll(
            '#mobile-menu nav > .menu > .menu-item'
        );
        this.isOpenned = false;
        this.isOpenning = false;
        this.tl = gsap.timeline({
            paused: true,
            onReverseComplete: () => {
                this.header.classList.remove('mobile-open');
                this.isOpenned = false;
            },
        });

        this.setTimeLine();

        this.events();
    }

    setTimeLine() {
        this.tl.to(this.nav, {
            duration: 0.5,
            y: '0%',
            ease: 'power1.easeOut',
        });

        this.tl.to(
            this.navItems,
            {
                duration: 0.3,
                opacity: 1,
                stagger: 0.075,
                ease: 'power1.easeOut',
            },
            '-=0.2'
        );
    }

    events() {
        this.trigger.addEventListener('click', () => this.toggleMenu());
    }

    toggleMenu() {
        if (this.isOpenned) {
            this.tl.timeScale(1.5);
            this.tl.reverse();
        } else {
            this.header.classList.add('mobile-open');
            this.tl.timeScale(1);
            this.tl.play();
            this.isOpenned = true;
        }
    }
}

export default new MobileMenu();
